// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://umrgttsbkuafhsxdufrn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVtcmd0dHNia3VhZmhzeGR1ZnJuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ4MjMyMTksImV4cCI6MjA2MDM5OTIxOX0.rk6ExwqG1qgwcfgZwI2EhAHbKgWE0x4dNnm1p2lxhWc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});